import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationService } from '../../services/application.service';
import { UserService } from '../../services/user.service';
import { InitializationAndConfigurationService } from '../../services/configuration/initializationAndConfiguration.service';
import { ToasterService } from 'angular2-toaster';
import { SystemMessage } from '../../models/system-message.model';

@Component({
  selector: 'app-show-system-messages',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="hasPermission('SYSTEM_MESSAGES_ALL')">Manage Active System Messages</h4>
      <h4 class="modal-title" *ngIf="!hasPermission('SYSTEM_MESSAGES_ALL')">Active System Messages</h4>
      <button type="button" class="btn-close close" (click)="close()"></button>
    </div>

    <div *ngIf="loadingMessages">
      Loading Messages.
    </div>

    <div *ngIf="!loadingMessages">
      <div class="modal-body modal-body-touch">
        <div *ngIf="systemMessages.length <= 0" class="row">
          <div class="col text-muted text-center"><i>There are no System Messages active in the system right now.</i></div>
        </div>
        <ul *ngIf="systemMessages.length > 0" class="list-group">
          <li class="list-group-item d-flex justify-content-between align-items-center"
              *ngFor="let message of systemMessages">
            {{message.message.length > 1000 ? (message.message.substring(0, 1000) + "...") : message.message}}
            <div style="text-wrap: nowrap">
              Expires: {{message.expirationTime | date:'MM/dd/yyyy HH:mm'}}&nbsp;&nbsp;&nbsp;&nbsp;
              <span *ngIf="hasPermission('SYSTEM_MESSAGES_ALL')" 
                    (click)="removeSystemMessage(message)" 
                    class="fa fa-trash-can text-danger" 
                    role="button"></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  `
})
export class ShowSystemMessagesComponent implements OnInit {
  @Output() closeModal = new EventEmitter<void>();

  systemMessages: SystemMessage[] = [];
  loadingMessages: boolean = false;
  private loggedInUser: any;

  constructor(
    private applicationService: ApplicationService,
    private userService: UserService,
    private initializationAndConfigurationService: InitializationAndConfigurationService,
    private toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.loggedInUser = this.initializationAndConfigurationService.getLoggedInUser();
    this.loadSystemMessages();
  }

  loadSystemMessages(): void {
    this.loadingMessages = true;
    this.applicationService.getActiveSystemMessages().subscribe({
      next: (messages) => {
        this.systemMessages = messages;
        this.loadingMessages = false;
      },
      error: (error) => {
        this.loadingMessages = false;
        this.toasterService.pop('error', 'Error loading system messages', error.message);
      }
    });
  }

  removeSystemMessage(message: SystemMessage): void {
    this.applicationService.removeSystemMessage(parseInt(message.id)).subscribe({
      next: () => {
        this.toasterService.pop('success', 'System Message removed');
        // Remove the message from the array
        const index = this.systemMessages.indexOf(message);
        if (index > -1) {
          this.systemMessages.splice(index, 1);
        }
      },
      error: (error) => {
        this.toasterService.pop('error', 'Error removing system message', error.message);
      }
    });
  }

  hasPermission(permission: string): boolean {
    return this.userService.hasPermission(permission, this.loggedInUser);
  }

  close(): void {
    this.closeModal.emit();
  }
}